export default {
  de: 'Deutsch',
  en: 'English'
}



// WEBPACK FOOTER //
// ./src/i18n/de/lang.js